export default {
  phenotype:
    "tw-bg-blueGray-300 tw-text-blueGray-800 tw-border-t tw-border-blueGray-200",
  disease:
    "tw-bg-blueGray-400 tw-text-blueGray-900 tw-border-t tw-border-blueGray-300",
  gene: "tw-bg-blueGray-800 tw-text-white",
};
